import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';


@Component({
	moduleId: module.id,
	selector: 'address',
	templateUrl: 'phone-number.component.html',
})
export class PhoneNumberComponent {
	@Input('group')
	public phoneNumberForm: FormGroup;
	public mask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/,/\d/, /\d/, /\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];

	typeChanged(type){
		console.log(type)
		if (type == 1 || type == 3){
			this.mask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];

		}else if (type == 2){
			this.mask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/,/\d/, /\d/, /\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];
		}

	}

}


// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/phone-number.component.ts